<template>
  <div>
    <BaseFormPaymentMethod
      :initialState="state"
      :state.sync="sync.state"
      :form.sync="sync.$formPayment"
      :onReset.sync="sync.onReset"
      :isSubmitted="isSubmitted"
      :inputClassName="inputClassName"
      inputCreditCardClassName="col-lg-6"
      inputCreditCardExpireClassName="col-lg-3"
      inputCreditCardCvvclassName="col-lg-3"
    />
  </div>
</template>

<script>
export default {
  props: {
    state: {
      required: true,
      type: Object,
      default: () => ({}),
    },
    isSubmitted: {
      required: true,
      type: Boolean,
      default: false,
    },
    inputClassName: {
      type: String,
      default: null,
    },
  },

  data () {
    return {
      sync: {
        state: {},
        $formPayment: null,
        onReset: null,
      },
    }
  },

  watch: {
    'sync.state': {
      handler: function () {
        this.$emit('update:form', this.sync.state)
      },
      deep: true,
    },
  },

  mounted () {
    this.$emit('update:validate', this.validate)
  },

  methods: {
    validate () {
      this.sync.$formPayment.$touch()
      if (this.sync.$formPayment.$invalid) {
        this.scrollToTop(600)
        return false
      }
      return true
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseCreditCardForm.vue